import { defaultHttpClient } from '../../httpClient';
import type {
  PostFacebookLoginRequest,
  PostFacebookLoginResponse,
} from './types';

/**
 * - 페이스북 access_token으로 로그인하는 API
 * - 성공 시 멤버 JWT 토큰(token)을 반환한다.
 */
export const postFacebookLogin = (params: PostFacebookLoginRequest) => {
  return defaultHttpClient
    .request<PostFacebookLoginResponse>({
      method: 'POST',
      url: '/api/v2/login/facebook/',
      data: params,
    })
    .then(result => result.data);
};
